var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import dayjs from 'dayjs';
import MemberAllocationApiClient, { getMemberAllocationTimelineTimeRange } from '@/plugins/apis/v2/member-allocation-api-client';
import { buildAllocationTaskFromApiProject } from '@/utils/member-allocation-format';
var USER_LIMIT = 20;
var MEMBER_SCROLL_CHUNK = 80;
function memberWindowCacheKey(options) {
    var rangeKey = getMemberAllocationTimelineTimeRange(options.timelineReference).rangeKey;
    return options.companyId + "::" + rangeKey + "::" + options.startOffset + "::" + options.chunkSize;
}
function buildDayKeysFromRange(startDate, endDate) {
    var start = dayjs(startDate);
    var end = dayjs(endDate);
    var days = [];
    var cur = start;
    while (!cur.isAfter(end)) {
        days.push(cur.format('YYYY-MM-DD'));
        cur = cur.add(1, 'day');
    }
    return days;
}
function mergeUsersIntoMaps(currentMembers, currentTasks, users, dayKeysForMonth, options) {
    var allowAddMembers = (options === null || options === void 0 ? void 0 : options.allowAddMembers) !== false;
    var targetMemberIds = options === null || options === void 0 ? void 0 : options.targetMemberIds;
    var existingMemberIds = new Set(currentMembers.map(function (m) { return m.id; }));
    for (var _i = 0, users_1 = users; _i < users_1.length; _i++) {
        var user = users_1[_i];
        var userId = user.id || '';
        if (!userId)
            continue;
        if (targetMemberIds && !targetMemberIds.has(userId))
            continue;
        var member = {
            id: userId,
            name: user.name,
            role: user.role || user.user_type || 'member',
            avatar: user.avatar
        };
        if (allowAddMembers && !existingMemberIds.has(userId)) {
            currentMembers.push(member);
            existingMemberIds.add(userId);
        }
        if (!currentTasks[userId]) {
            currentTasks[userId] = {};
        }
        var row = currentTasks[userId];
        for (var _a = 0, dayKeysForMonth_1 = dayKeysForMonth; _a < dayKeysForMonth_1.length; _a++) {
            var d = dayKeysForMonth_1[_a];
            if (!row[d]) {
                row[d] = [];
            }
        }
        for (var _b = 0, _c = user.days; _b < _c.length; _b++) {
            var day = _c[_b];
            var tasks = [];
            for (var _d = 0, _e = day.projects; _d < _e.length; _d++) {
                var project = _e[_d];
                for (var _f = 0, _g = project.large_processes; _f < _g.length; _f++) {
                    var lp = _g[_f];
                    tasks.push(buildAllocationTaskFromApiProject(project, lp));
                }
            }
            row[day.date] = tasks;
        }
    }
}
function fetchValidMemberWindow(options) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var companyId, startOffset, chunkSize, timelineReference, members, tasksByMemberAndDay, offset, nextOffset, hasMoreUsers, totalUsers, days, isFirstRequest, res, data, metaNextOffset;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    companyId = options.companyId, startOffset = options.startOffset, chunkSize = options.chunkSize, timelineReference = options.timelineReference;
                    members = [];
                    tasksByMemberAndDay = {};
                    offset = startOffset;
                    nextOffset = startOffset;
                    hasMoreUsers = true;
                    totalUsers = null;
                    days = [];
                    isFirstRequest = true;
                    _e.label = 1;
                case 1:
                    if (!(members.length < chunkSize && hasMoreUsers)) return [3 /*break*/, 3];
                    return [4 /*yield*/, MemberAllocationApiClient.fetchTimeline(companyId, {
                            user_offset: offset,
                            user_limit: chunkSize,
                            timelineReference: timelineReference
                        })];
                case 2:
                    res = _e.sent();
                    data = res.data;
                    if (isFirstRequest) {
                        days = buildDayKeysFromRange(data.start_date, data.end_date);
                        isFirstRequest = false;
                    }
                    if (typeof ((_a = data.meta) === null || _a === void 0 ? void 0 : _a.total_users) === 'number') {
                        totalUsers = data.meta.total_users;
                    }
                    mergeUsersIntoMaps(members, tasksByMemberAndDay, data.users || [], days);
                    if (members.length > chunkSize) {
                        members.splice(chunkSize);
                    }
                    metaNextOffset = (_b = data.meta) === null || _b === void 0 ? void 0 : _b.next_user_offset;
                    hasMoreUsers = !!((_c = data.meta) === null || _c === void 0 ? void 0 : _c.has_more_users) && metaNextOffset != null;
                    if (!hasMoreUsers || metaNextOffset == null || metaNextOffset <= offset) {
                        nextOffset = offset + (((_d = data.users) === null || _d === void 0 ? void 0 : _d.length) || 0);
                        return [3 /*break*/, 3];
                    }
                    nextOffset = metaNextOffset;
                    offset = metaNextOffset;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, {
                        members: members,
                        tasksByMemberAndDay: tasksByMemberAndDay,
                        days: days,
                        totalUsers: totalUsers,
                        nextOffset: nextOffset,
                        hasMoreUsers: hasMoreUsers || (typeof totalUsers === 'number' && nextOffset < totalUsers)
                    }];
            }
        });
    });
}
/**
 * Browser-side timeline window cache + in-flight dedupe. Lives outside Vuex so Maps/Promises
 * are not serialized into store state; reset() ties cache invalidation to store init.
 */
var MemberAllocationWindowCacheService = /** @class */ (function () {
    function MemberAllocationWindowCacheService() {
        this.cache = new Map();
        this.inFlight = new Map();
        this.generation = 0;
        this.bypassUntil = 0;
    }
    MemberAllocationWindowCacheService.prototype.getGeneration = function () {
        return this.generation;
    };
    MemberAllocationWindowCacheService.prototype.setBypassUntil = function (timestampMs) {
        this.bypassUntil = timestampMs;
    };
    MemberAllocationWindowCacheService.prototype.reset = function () {
        this.generation += 1;
        this.cache.clear();
        this.inFlight.clear();
    };
    MemberAllocationWindowCacheService.prototype.fetchMemberWindowWithCache = function (options, preferCache) {
        var _this = this;
        if (preferCache === void 0) { preferCache = true; }
        var shouldBypassCache = Date.now() < this.bypassUntil;
        var key = memberWindowCacheKey(options);
        if (!shouldBypassCache && preferCache && this.cache.has(key)) {
            return Promise.resolve(this.cache.get(key));
        }
        if (!shouldBypassCache && this.inFlight.has(key)) {
            return this.inFlight.get(key);
        }
        var requestGeneration = this.generation;
        var request = fetchValidMemberWindow(options).then(function (data) {
            if (requestGeneration === _this.generation) {
                _this.cache.set(key, data);
            }
            _this.inFlight.delete(key);
            return data;
        });
        this.inFlight.set(key, request);
        return request;
    };
    MemberAllocationWindowCacheService.prototype.prefetchMemberWindow = function (options) {
        var _this = this;
        if (Date.now() < this.bypassUntil)
            return;
        if (options.startOffset < 0)
            return;
        var key = memberWindowCacheKey(options);
        if (this.cache.has(key) || this.inFlight.has(key))
            return;
        this.fetchMemberWindowWithCache(options, false).catch(function () {
            _this.inFlight.delete(key);
        });
    };
    return MemberAllocationWindowCacheService;
}());
export var memberAllocationWindowCache = new MemberAllocationWindowCacheService();
export { USER_LIMIT, MEMBER_SCROLL_CHUNK, mergeUsersIntoMaps, buildDayKeysFromRange };
